module.exports = vendor_lib;


//////////////////
// WEBPACK FOOTER
// external "vendor_lib"
// module id = 6
// module chunks = 1